import { Component, Input, output } from '@angular/core';

import type {
  ActivitySubscriptionType,
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { GdprService } from '@recruitee/gdpr-data';
import { TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-follow-candidate',
  templateUrl: './activity-subscriptions-follow-candidate.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  imports: [
    ActivitySubscriptionsTableComponent,
    TranslatePipe,
    ActivitySubscriptionsTableRowComponent,
  ],
})
export class ActivitySubscriptionsFollowCandidateComponent {
  @Input() public hasOverdueCandidates: boolean;
  @Input() public types: ActivitySubscriptionType[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public abilities = {
    manageCandidates: false,
  };
  public changeEvents = output<ActivitySubscriptionUpdateData>();

  constructor(public gdprService: GdprService) {}
}
